/**
 * Check if Auth0 authentication is enabled.
 * Auth0 is used for every region; this stays async so callers need no changes.
 *
 * E2E builds default to the non-Auth0 path so legacy builders (mobile,
 * web) can drive their existing login flows without an Auth0 redirect.
 * Experience-builder's e2e setup (see `e2e/setup/auth.js`) needs Auth0
 * and opts in by seeding `USE_AUTH0=true` in localStorage before the
 * bundle executes — honor that opt-in here.
 */
export const isAuth0Enabled = async (): Promise<boolean> => {
  if (import.meta.env.E2E) {
    return localStorage.getItem('USE_AUTH0') === 'true';
  }

  return true;
};
